import React from 'react';
import { StructuredHtmlData } from './structureHtmlData';
import ParagraphHtmlComponent from '../HtmlTagComponents/ParagraphHtmlComponents';
import ImageHtmlComponent from '../HtmlTagComponents/ImageHtmlComponents';

const renderHtmlComponents = (structuredHtmlData: StructuredHtmlData[]): JSX.Element[] => {
  return structuredHtmlData.map((data, index) => {
    if (data.type === 'tag' && data.tagName === 'p')
      return (
        <ParagraphHtmlComponent
          key={`${index}`}
          structuredHtml={data}
        />
      );
    if (data.type === 'tag' && data.tagName === 'img')
      return (
        <ImageHtmlComponent
          key={`${index}`}
          structuredHtml={data}
        />
      );
    return null;
  });
};

export default renderHtmlComponents;
